module.exports = __webpack_public_path__ + "static/media/coming-soon.a808301a.png";